import efektivitas from '../../../../assets/img/product/efektifitas.svg'
import kas from '../../../../assets/img/product/kas.svg'
import referensi from '../../../../assets/img/product/referensi.svg'
import replacement from '../../../../assets/img/product/replacement.svg'
export default function KeuntunganPerusahaanMitra(){
    return(
        <div className='container-alur'>
            <h2 className='text-header'>Kelebihan Menjadi Mitra</h2>
            <div className='kelebihan-pendana pb-20'>
                <div className='section'>
                    <img src={efektivitas} alt='efektifitas'/>
                    <p><b>Efektivitas Biaya</b></p>
                    <p>Perusahaan tidak perlu mengalokasikan dana atau budget dalam hal penyediaan fasilitas kesejakteraan karyawan</p>
                </div>
                <div className='section'>
                    <img src={kas} alt='kas'/>
                    <p><b>Kas</b></p>
                    <p>Dengan adanya alternatif pendanaan dari Danai.id dalam penyediaan program benefit untuk karyawan, maka arus tunai perusahaan akan terbantu</p>
                </div>
                <div className='section'>
                    <img src={referensi} alt='referensi'/>
                    <p><b>Program Referensi</b></p>
                    <p>Perusahaan dapat memiliki program retensi</p>
                </div>
                <div className='section'>
                    <img src={replacement}
                         alt='pergantian'/>
                    <p><b>Kelola Pergantian Karyawan</b></p>
                    <p>Menjaga pergantian karyawan dan memiliki daya saing untuk mendapatkan/mempertahankan karyawan
                        yang baik</p>
                </div>
            </div>
        </div>
    );
}